import React, { useState } from 'react';
import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import UserDetails from './details/UserDetails';
import UserDetailsHeader from './details/UserDetailsHeader';
import { isOwner } from '../../utils/AppUtil';
import DeleteOwnAccountConfirmationDialog from './details/DeleteOwnAccountConfirmationDialog';

const UserDetailDisplay = ({
  accountId,
  viewerId,
  viewerRole,
  user,
  accountLegalName,
  userRole,
  toggleChangePassword,
  toggleUpdateDetails,
  toggleChangeOwner,
}) => {
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  const { id: userId } = user;

  const userIsViewingOwnPage = viewerId === userId;
  const userIsOwner = isOwner(viewerRole);

  return (
    <>
      <DeleteOwnAccountConfirmationDialog
        accountId={accountId}
        accountLegalName={accountLegalName}
        userId={viewerId}
        userIsOwner={userIsOwner}
        visible={showConfirmationDialog}
        hide={() => setShowConfirmationDialog(false)}
        toggleChangeOwner={toggleChangeOwner}
      />
      <div className="p-grid">
        <div className="p-col-12">
          <Panel
            header={
              <UserDetailsHeader
                user={user}
                userIsViewingOwnPage={userIsViewingOwnPage}
                toggleUpdateDetails={toggleUpdateDetails}
                toggleChangePassword={toggleChangePassword}
                handleDeletingUser={() => setShowConfirmationDialog(true)}
              />
            }
          >
            <UserDetails user={user} userRole={userRole} />
          </Panel>
        </div>
      </div>
    </>
  );
};

UserDetailDisplay.propTypes = {
  accountId: PropTypes.string.isRequired,
  viewerId: PropTypes.string.isRequired,
  viewerRole: PropTypes.string.isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  accountLegalName: PropTypes.string.isRequired,
  userRole: PropTypes.string.isRequired,
  toggleEdit: PropTypes.func.isRequired,
  toggleChangePassword: PropTypes.func.isRequired,
  toggleUpdateDetails: PropTypes.func.isRequired,
  toggleChangeOwner: PropTypes.func.isRequired,
};

export default UserDetailDisplay;
